// src/layouts/admin/AdminMasterLayout.jsx
import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";   
import AdminSidebar from "../../components/admin/adminsidebar/AdminSidebar";
import AdminTopbar from "../../components/admin/admintopbar/AdminTopbar";
import '../../assets/css/admin/layouts/AdminLayouts.css';
import useScrollToTop from "../../contexts/UseScrolltoTop";

const AdminMasterLayout = ({ children }) => {
  useScrollToTop();
  const navigate = useNavigate(); 
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);

  const toggleMobileSidebar = () => setIsMobileSidebarOpen((prev) => !prev);
  const closeMobileSidebar = () => setIsMobileSidebarOpen(false);

  const token = localStorage.getItem("adminAuthToken");

  if (!token) {
    navigate("/admin/login");
    return null;
  }

  return (
    <div className="admin-master-layout">
      <Row className="g-0">
        <Col lg={4} md={4} sm={12} className="sidebar-col">
          <AdminSidebar
            isMobileOpen={isMobileSidebarOpen}
            onCloseMobile={closeMobileSidebar}
          />
        </Col>
        <Col lg={8} md={8} sm={12} className="content-col">
          <AdminTopbar onToggleSidebar={toggleMobileSidebar} />
          <div className="admin-content-wrapper">
            {children}
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default AdminMasterLayout;